import ThisModule from "./LocalStorageProvider";

export default ThisModule;
